import config from '../config';
import {
  loadAllQuotes,
  loadAllQuotesFailed,
  loadAllQuotesClient,
  setQuoteStatusByQuoteClientId,
  loadQuoteById,
  updateTokenQuoteByUserEmailAndPassword,
  addQuote,
  removeQuoteById,
  archiveQuote, getPreViewHtmlQuote,
  actionGetHistoryUpdated
} from '../actions/quotes';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { path } from 'ramda';
import { push } from 'react-router-redux';
import { addNewTask } from './task';
import { loadDetailProjectTask } from '../actions/dashboard';
import fetch2 from 'cross-fetch';
import { removeQuoteFromArchive } from '../actions/archive';

export function createWOBasedOnQuoteData(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      data.sales_rep_id = 113;
      addNewTask(data, 'quotes-wo')(dispatch);
    }
  }
}

export function fetchAllQuotes() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadAllQuotes({ list: json }));
          }
        })
        .catch(response => dispatch(loadAllQuotesFailed({ error: response })));
    }
  }
};

export function fetchAllQuotesClient() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote/getQuoteListClient`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadAllQuotesClient({ quoteList: json }));
          }
        })
    }
  }
};

export function sendEmail(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quoteSend/sendQuote/${data.id}`, {
        method: 'POST',
        body: JSON.stringify({recipients: data.recipients}),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json.sent === true) {
              dispatch(notify({
                title: 'Send Quote',
                message: 'Quote sent successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            } else if (json.code == 410) {
              dispatch(notify({
                title: 'Send Quote',
                message: json.detail,
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          }
        })
    }
  }
};

export function archiveQuoteById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote/archive/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json.code != 410) {
              if (!json.error) {
                dispatch(archiveQuote({ id }));
                dispatch(notify({
                  title: 'Archive Quote',
                  message: 'Quote archived successfully',
                  status: 'success',
                  position: 'tr',
                  dismissible: true,
                  dismissAfter: 3000
                }));
              }
              else {
                dispatch(notify({
                  title: 'Archive Quote',
                  message: json.error,
                  status: 'error',
                  position: 'tr',
                  dismissible: true,
                  dismissAfter: 3000
                }));
              }
            }
          }
        })
    }
  }
};

export function adjustQuoteStatusByQuoteClientId(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote/setStatusQuoteByQuoteClientId/${data.id}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(setQuoteStatusByQuoteClientId({ quote: json }));
          }
        })
    }
  }
};

export function fetchQuoteById(id) {
  return (dispatch) => {
    return fetch(`${config.apiEndpoint}/quote/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          if (json && json.code != 404) {
            const tasksObject = path(['wo'], json) || null;
            if (tasksObject) {
              const tasks = Object.values(tasksObject);
              dispatch(loadDetailProjectTask(tasks));
            }
            dispatch(loadQuoteById({ quote: json }));
          } else {
            dispatch(notify({
              title: 'Load Quote',
              message: 'Failed to load Quote',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        }
      })
  }
};

export function fetchQuoteByIdWithRole(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote/auth/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json && json.code != 404) {
              const tasksObject = path(['wo'], json) || null;
              if (tasksObject) {
                const tasks = Object.values(tasksObject);
                dispatch(loadDetailProjectTask(tasks));
              }
              dispatch(loadQuoteById({ quote: json }));
            } else {
              dispatch(notify({
                title: 'Load Quote',
                message: 'Failed to load Quote',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          }
        })
    }
  }
};

export function getPreView(id) {
  return (dispatch) => {
    return fetch2(`${config.apiEndpoint}/quote/getViewOfQuoteById/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        return response.text();
      })
      .then(text => {
        if (text) {
          dispatch(getPreViewHtmlQuote({ html: text }));
        }
      })
  }
};

export function updateTokenQuoteByUserEmailAndPass(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote/updateToken`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(updateTokenQuoteByUserEmailAndPassword({ quote: json }));
          }
        })
    }
  }
};

export function updateQuoteStatus(id, formData) {
  return (dispatch) => {
    return fetch(`${config.apiEndpoint}/quote/updateStatus/${id}`, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          window.location.reload();
        }
      })
  }
};

export function createQuote(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote/addQuote`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            // dispatch(addQuote({ quote: json }));
            dispatch(push('/pages/quotes-edit/' + json.quote_id));
            dispatch(notify({
              title: 'Add New Quote',
              message: 'Quote added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));

            setTimeout(function() {
              window.location.reload();
            }, 10);
          }
        })
    }
  }
};

export function getPdfFileForQuote(id) {
  return (dispatch) => {
    return fetch(`${config.apiEndpoint}/quote/getViewOfQuoteByIdInPdf/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const newBlob = new Blob([blob], { type: "application/pdf" })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        window.open(data);

        setTimeout(function() {
          // For Firefox it is necessary to delay revoking the ObjectURL
          //window.URL.revokeObjectURL(data);
        }, 100);

      })
      .catch(response => {
        dispatch(notify({
          title: 'PDF Download',
          message: 'Failed to download PDF',
          status: 'error',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }));
      });
  }
};

export function updateQuote(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote/editQuote/${data.id}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(notify({
              title: 'Update Quote',
              message: 'Quote updated successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));

            setTimeout(function() {
              window.location.reload();
            }, 1000);
          }
        })
    }
  }
};

export function deleteQuoteById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/quote/deleteQuote/${data.id}`, {
        method: 'DELETE',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(removeQuoteById({ id: data.id }));
            dispatch(notify({
              title: 'Delete Quote',
              message: 'Quote deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

export function reopenArchiveQuote(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/archive/quote/${data.id}`, {
        method: 'POST',
        body: JSON.stringify({}),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json.code !== 410) {
              // dispatch(reopenArchive({ dynamicList: json }));
              dispatch(removeQuoteFromArchive(data.id));
              dispatch(notify({
                title: 'Reopent Quote',
                message: 'Quote reopened successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            } else {
              dispatch(notify({
                title: 'Reopent Quote',
                message: 'Failed to reopen quote',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          }
        })
    }
  }
}

export function getHistory(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskHistory/${id}/2`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.text();
        })
        .then(text => {
          if (text) {
            dispatch(actionGetHistoryUpdated({
              historyUpdated: text,
            }));
          }
        })
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/quotes.js